const {
  PRODUCTS,
  PRICES,
  PAYMENT_METHODS,
  getDiscountFromPromoCode,
} = require('acces-impot-utils/lib/price')

module.exports = {
  PRODUCTS,
  PRICES,
  PAYMENT_METHODS,
  getDiscountFromPromoCode,
}
